import apiRequest from "utils/apiRequestWithErrorCode";
import {
  EmailFlowLogsSearchResponse,
  EmailFlowLogsSearchRequest,
  EmailFlowLogReportRequest,
  EmailFlowLogReport,
  EmailLogReportsResponse,
  EmailFlowLog,
} from "@dashboard-v3/api";

export async function searchLogs(criteria: EmailFlowLogsSearchRequest) {
  return apiRequest<EmailFlowLogsSearchResponse>(
    "POST",
    "/emailflow-logs/search",
    criteria
  );
}

export async function getEmailLogById(id: string) {
  return apiRequest<EmailFlowLog>(
    "GET",
    `/emailflow-logs/${encodeURIComponent(id)}`
  );
}

export async function createLogsReport(criteria: EmailFlowLogReportRequest) {
  return apiRequest<EmailFlowLogReport>(
    "POST",
    "/emailflow-logs/reports",
    criteria
  );
}

export async function getAllEmailLogReports(rowsPerPage: number, page: number) {
  return apiRequest<EmailLogReportsResponse>(
    "GET",
    `/emailflow-logs/reports?pageSize=${rowsPerPage}&page=${page}`
  );
}

export async function getEmailLogReportById(id: string) {
  return apiRequest<EmailFlowLogReport>("GET", `/emailflow-logs/reports/${id}`);
}

export async function cancelReport(id: string) {
  return apiRequest<EmailFlowLogReport>(
    "PATCH",
    `/emailflow-logs/reports/${id}/cancel`
  );
}
